import { Controller } from "stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "form"]

  initialize() {
    this.modal = new Modal(this.modalTarget)
    this.modal.show()
  }

  submit() {
    this.modal.hide()
  }
}
